import { Badge } from '@mantine/core'
import { forwardRef } from 'react'
import type { Props } from '../node/definition'
import IconSvg from '@packages/icon-svg'


export default forwardRef((p: Props) => {
	if (!p.label) return null

	const LeftIcon = p.leftIcon
		? <IconSvg iconName={p.leftIcon} iconSize='12' iconStroke='2' />
		: null
	const RightIcon = p.rightIcon
		? <IconSvg iconName={p.rightIcon} iconSize='12' iconStroke='2' />
		: null

	// const LeftIcon = p.leftIcon && p.leftIcon in R.libs.icons
	// 	? R.libs.icons[p.leftIcon as keyof typeof R.libs.icons]
	// 	: null
	// const RightIcon = p.rightIcon && p.rightIcon in R.libs.icons
	// 	? R.libs.icons[p.rightIcon as keyof typeof R.libs.icons]
	// 	: null
	return (
		<Badge
			leftSection={LeftIcon ? LeftIcon : undefined}
			rightSection={RightIcon ? RightIcon : undefined}
			{...p} {...p.customProps}
		>
			{p.label}
		</Badge>
	)
})
